import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { BankStatementRuleFindInterface } from '@zaoblako/shared/modules/document/dtos/bank-statement-rule/bank-statement-rule-find.dto';
import type { BankStatementRulePageInterface } from '@zaoblako/shared/modules/document/dtos/bank-statement-rule/bank-statement-rule-page.dto';
import type { BankStatementRuleQueryInterface } from '@zaoblako/shared/modules/document/dtos/bank-statement-rule/bank-statement-rule-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentRegulationService extends BaseService {
  protected baseUrl = '/finance/document/bank-statement-rule';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: BankStatementRuleQueryInterface): Observable<BankStatementRulePageInterface> {
    return this.http.get<BankStatementRulePageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public restoreOne(id: number): Observable<BankStatementRuleFindInterface> {
    return this.http.post<BankStatementRuleFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }
}
